import React from 'react';
import { string, arrayOf, shape } from 'prop-types';
import css from './SectionTrust.module.css';

const CertBadge = ({ name }) => (
  <a
    href={`/s?keywords=${encodeURIComponent(name + ' certified')}`}
    className={css.certBadge}
    title={`Browse ${name}-certified trainers`}
  >
    {name}
  </a>
);

const ICONS = {
  verified: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      <polyline points="9 12 11 14 15 10" />
    </svg>
  ),
  certified: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="8" r="6" />
      <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11" />
    </svg>
  ),
  pricing: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="12" y1="1" x2="12" y2="23" />
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
    </svg>
  ),
  secure: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  ),
  guarantee: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  cancel: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  ai: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 2l1.5 4.5L18 8l-4.5 1.5L12 14l-1.5-4.5L6 8l4.5-1.5z" />
      <path d="M19 14l.75 2.25L22 17l-2.25.75L19 20l-.75-2.25L16 17l2.25-.75z" />
      <path d="M5 17l.5 1.5L7 19l-1.5.5L5 21l-.5-1.5L3 19l1.5-.5z" />
    </svg>
  ),
};

const SectionTrust = props => {
  const { title, subtitle, cards, certifications } = props;

  return (
    <section className={css.root}>
      <div className={css.container}>
        <h2 className={css.title}>{title}</h2>
        {subtitle && <p className={css.subtitle}>{subtitle}</p>}

        {certifications && certifications.length > 0 && (
          <div className={css.certRow} aria-label="Accepted certifications">
            <span className={css.certLabel}>Accepted certifications:</span>
            {certifications.map(cert => (
              <CertBadge key={cert} name={cert} />
            ))}
          </div>
        )}

        <div className={css.grid}>
          {cards.map((card, index) => {
            const inner = (
              <>
                <div className={css.icon}>{ICONS[card.icon] || null}</div>
                <h3 className={css.cardTitle}>{card.title}</h3>
                <p className={css.cardDescription}>{card.description}</p>
                {card.link && <span className={css.cardLink}>Learn more →</span>}
              </>
            );
            return card.link ? (
              <a key={index} href={card.link} className={`${css.card} ${css.cardLinked}`}>
                {inner}
              </a>
            ) : (
              <div key={index} className={css.card}>
                {inner}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

SectionTrust.defaultProps = {
  subtitle: null,
  cards: [],
  certifications: null,
};

SectionTrust.propTypes = {
  title: string.isRequired,
  subtitle: string,
  certifications: arrayOf(string),
  cards: arrayOf(
    shape({
      icon: string.isRequired,
      title: string.isRequired,
      description: string.isRequired,
      link: string,
    })
  ),
};

export default SectionTrust;
